/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/bootstrap.js to modify the generation of this file.
module.exports = {
  "sitecoreApiKey": "no-api-key-set",
  "sitecoreApiHost": "http://static.local",
  "jssAppName": "reactclean",
  "defaultLanguage": "en",
  "graphQLEndpointPath": "/api/reactclean",
  "proxyHost": null,
  "graphQLEndpoint": "http://static.local/api/reactclean?sc_apikey=no-api-key-set"
};